/**
 * Production-safe logger utility
 *
 * In development: logs normally to console
 * In production: logs are disabled to prevent leaking sensitive data
 *
 * Usage:
 * ```typescript
 * import { logger } from '@/core/utils/logger'
 *
 * logger.log('User logged in:', user)
 * logger.error('Failed to fetch data:', error)
 * logger.warn('API rate limit approaching')
 * logger.debug('Debugging info:', data)
 * ```
 */

const isProduction = import.meta.env.PROD

// No-op function for production
const noop = () => {}

export const logger = {
  /**
   * General log message
   * Disabled in production
   */
  log: isProduction ? noop : console.log.bind(console),

  /**
   * Error logging
   * Still logs to console in production, but sanitized by Sentry
   */
  error: console.error.bind(console),

  /**
   * Warning message
   * Disabled in production
   */
  warn: isProduction ? noop : console.warn.bind(console),

  /**
   * Debug message
   * Disabled in production
   */
  debug: isProduction ? noop : console.debug.bind(console),

  /**
   * Info message
   * Disabled in production
   */
  info: isProduction ? noop : console.info.bind(console),

  /**
   * Table display
   * Disabled in production
   */
  table: isProduction ? noop : console.table.bind(console)
}
